var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.2,
  d: "M7.01 9.273c.82 0 1.731.118 2.736.363 1.138.284 2.03.658 2.694 1.105l.003.002c.796.527 1.077 1.037 1.078 1.514v1.264H.5v-1.264c0-.477.281-.987 1.077-1.514l.003-.002c.664-.447 1.556-.82 2.693-1.104Q5.78 9.27 7.01 9.273ZM7.01.5c.541 0 1.034.134 1.487.402q.684.403 1.092 1.11c.27.47.405.972.405 1.514s-.134 1.035-.402 1.488q-.407.687-1.095 1.093a2.86 2.86 0 0 1-1.487.403 2.86 2.86 0 0 1-1.488-.403A3.06 3.06 0 0 1 4.43 5.014a2.86 2.86 0 0 1-.403-1.488q0-.811.406-1.513c.272-.473.634-.84 1.09-1.11A2.86 2.86 0 0 1 7.01.5Z"
})));
export default SvgUserOutline;